import type { ReactNode } from "react";
import { Link, useLocation, useNavigate } from "react-router";
import { PageHeader } from "../../app/PageHeader";

/** Tabbladen van Platformbeheer (docs/VERKOOP.md). */
const TABS = [
  { to: "/platform", label: "Organisaties" },
  { to: "/platform/klanten", label: "Klanten" },
  { to: "/platform/offertes", label: "Offertes" },
  { to: "/platform/facturatie", label: "Facturatie" },
] as const;

export function platformTab(pathname: string): string {
  if (pathname.startsWith("/platform/klanten")) return "/platform/klanten";
  if (pathname.startsWith("/platform/offertes")) return "/platform/offertes";
  if (pathname.startsWith("/platform/facturatie")) return "/platform/facturatie";
  return "/platform";
}

/** Kop van Platformbeheer met de tabbladen; Kennisbank, Helpcenter, Support en Status onder ⋯. */
export function PlatformHeader({ title, action }: { title: ReactNode; action?: ReactNode }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const current = platformTab(pathname);
  return (
    <PageHeader
      label="Platformbeheer"
      title={title}
      action={action}
      menu={
        <>
          <Link className="menuitem" to="/platform/kennisbank">
            Kennisbank
          </Link>
          <Link className="menuitem" to="/platform/helpcenter">
            Helpcenter
          </Link>
          <Link className="menuitem" to="/platform/support">
            Support
          </Link>
          <Link className="menuitem" to="/platform/status">
            Status
          </Link>
        </>
      }
      tabs={
        <div className="tabs" role="tablist" aria-label="Platformbeheer">
          {TABS.map((t) => (
            <button
              key={t.to}
              type="button"
              role="tab"
              aria-selected={current === t.to}
              onClick={() => void navigate(t.to)}
            >
              {t.label}
            </button>
          ))}
        </div>
      }
    />
  );
}
